// SPDX-License-Identifier: AGPL-3.0-or-later

import {makePersistent} from '@app/features/platform/utils/MobXPersistence';
import {initializeStore} from '@app/features/platform/utils/StoreInitialization';
import {makeAutoObservable} from 'mobx';

/**
 * 发现页「AI 陪聊」的客户端偏好。默认角色仅影响本机开始入口选中的角色,
 * 不写入服务端;服务端目录的默认角色仍由实例配置决定。
 */
class CompanionTalkPreferences {
	defaultSceneId: string | null = null;

	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
		initializeStore(this, () => this.initPersistence());
	}

	private async initPersistence(): Promise<void> {
		await makePersistent(this, 'CompanionTalkPreferences', ['defaultSceneId']);
	}

	setDefaultScene(sceneId: string | null): void {
		this.defaultSceneId = sceneId;
	}
}

const companionTalkPreferences = new CompanionTalkPreferences();

export default companionTalkPreferences;
